import { useState, useEffect, useRef } from "react"
import React from 'react'
import { useForm } from '../forms/useForm';
import 'moment/locale/es';
import moment from 'moment';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { getGlobalCash, createCashGlobal, createCashExtemporaneous, updateModifiedAmount } from '../../services/cashFlow/cashFlow'
import { getAllPayMethod } from '../../services/payMethod/payMethod';
import { ConfigServer } from "../../data/config";






export const useCashGlobal = () => {

    // * GLOBALES
    let _commercialLine = localStorage.getItem('CommercialLineShort');
    let _nameUser = localStorage.getItem('nameUser');
    let _branchName = localStorage.getItem('branchName');
    let _admin_cash = localStorage.getItem('admin_cash');
    let _active_micro = localStorage.getItem('active_microsanitary');
    let _url_helen = localStorage.getItem('url_helen');

    const [createSweet] = useSweetAlert();

    // ? GLOBAL CASH
    const [dataAllGlobal, setDataAllGlobal] = useState([])
    const [amount1, setAmount1] = useState(0);
    const [loadingGlobal, setLoadingGlobal] = useState(false)
    const [amountTotal, setAmountTotal] = useState(0);
    const [amountCancell, setAmountCancell] = useState(0);


    // ? AUTHORIZATION CASH
    const [selectedKey, setSelectedKey] = useState(null);
    const [modalAuthorization, setModalAuthorization] = useState(false);
    const [viewAmount, setViewAmount] = useState(null)
    const [user, setUser] = useState(null)

    // ? PREVIEW
    const [viewDetail, setViewDetail] = useState(false);
    const [id_cash, setId_cash] = useState(null);

    // ? EXTEMPORANEOUS
    const [visibleTicket, setVisibleTicket] = useState(false);
    const [infoTicket, setInfoTicket] = useState([]);
    const toast = useRef(null);
    const [userCapture, setUserCapture] = useState("");
    const [loadingExtemporaneous, setLoadingExtemporaneous] = useState(false)


    const [showAlert, setShowAlert] = useState(false);
    const [loadingPrintKey, setLoadingPrintKey] = useState(null);

    //? TOAST ALERT 
    const [showToast, setShowToast] = useState(false);
    const [toastType, setToastType] = useState("info");
    const [toastTitle, setToastTitle] = useState("");
    const [toastMessage, setToastMessage] = useState("");

    // ?  MODIFIED AMOUNT
    const [visibleInfo, setVisibleInfo] = useState(false);



    const showToastAlert = (
        type = "info",
        title = "",
        message = ""
    ) => {

        setToastType(type);
        setToastTitle(title);
        setToastMessage(message);
        setShowToast(true);

    };


    const closeToastAlert = () => {

        setShowToast(false);
        setToastTitle("");
        setToastMessage("");

    };




    // ? FORM CASH
    const [formValues, handleInputChange, reset, handleUpdateValues, handleSelectValues, handlePickerValues] = useForm({
        date1: "",
        date2: "",
    });

    const { date1, date2 } = formValues;

    // * CONFIGURATION GLOBAL
    const today = moment().format("YYYY-MM-DD");
    let _date1 = (date1 === '') ? today : moment(date1).format("YYYY-MM-DD");
    let _date2 = (date2 === '') ? today : moment(date2).format("YYYY-MM-DD");

    // *CONFIGURATION DATE
    const now = new Date();

    const fecha = now.toLocaleDateString("es-MX");
    const hora = now.toLocaleTimeString("es-MX");

    const _new = `${fecha} ${hora}`;

    // * CONFIGURATION PREVIEW

    const handleOpenPreview = () => {
        setViewDetail(true)
    }

    const handleClosedPreview = () => {
        setViewDetail(false)
    }


    // * EFFECTS
    useEffect(() => {
        handleGetGlobalCash()
        handleGetPayMethods()
    }, [])

    // * TOOGLE
    const toogleAuthorization = () => {
        setModalAuthorization(!modalAuthorization)
    }

    // ? METHOD GLOBAL
    const handleGetGlobalCash = async (_valid) => {

        setLoadingGlobal(true)
        const allCash = await getGlobalCash(_date1, _date2);

        if (allCash?.length > 0) {
            if (_valid) {
                setLoadingExtemporaneous(false)
                showToastAlert("success", "Información recopilada", "Corte de Caja Extemporaneo realizado correctamente.");

                //  createSweet("success", "success", "");
                hideModalTicket()
            }

            setLoadingGlobal(false)

            let _update = [];

            allCash.forEach(_branch => {
                let _sum_amountCash = 0;

                _branch.detailBranches.forEach(_pay => {
                    _pay.cash.forEach(_cashItem => {
                        _sum_amountCash += Number(_cashItem?.captureAmount ?? 0);
                    });
                });

                _update.push({
                    ..._branch,

                    // No sobrescribas amount, amount_cancell ni amount_total.
                    // Ya vienen calculados correctamente desde el backend.
                    amountCash: _sum_amountCash
                });
            });

            // let _update = [];


            // allCash.forEach(_branch => {
            //     let _sum_branch = 0;
            //     let _sum_amountCash = 0;

            //     _branch.detailBranches.forEach(_pay => {
            //         _pay.pay_methods.forEach(_amount => {
            //             if (_amount?.id_pay_method === 1) {
            //                 _sum_branch += _amount?.amount;
            //             }
            //         });

            //         _pay.cash.forEach(_cashItem => {
            //             _sum_amountCash += _cashItem?.amount ?? 0
            //         });
            //     });

            //     _update.push({
            //         ..._branch,
            //         amount: _sum_branch,
            //         amountCash: _sum_amountCash,
            //     });
            // });

            setDataAllGlobal(_update);
            setAmount1(_update.reduce((acc, branch) => acc + branch.amount, 0));
            setAmountTotal(_update.reduce((acc, branch) => acc + branch.amount_total, 0));
            setAmountCancell(_update.reduce((acc, branch) => acc + branch.amount_cancell, 0));
        } else {
            setDataAllGlobal([]);
        }
    };

    // ? CONFIGURATION AUTHORIZATION CASH
    const handleSearchAuthorization = (_key_user, _key_branch, _key_detail, _amounts, _user, _id_cash, _search, _key) => {
        const key = `${_key_user}-${_key_branch}-${_key_detail}`;

        const cashSelected = _search?.cash?.[_key_detail];

        console.log("Caja seleccionada:", cashSelected);

        const payMethods =
            cashSelected?.status === "Pendiente"
                ? _search?.pay_methods_pending
                : _search?.pay_methods_cut;

        setSelectedKey(prevSelectedKey => (prevSelectedKey === key ? null : key));
        setModalAuthorization(!modalAuthorization)
        setViewAmount(payMethods)
        setUser(_user)
        setId_cash(_id_cash)
    };

    // ? SAVE CHANGUES
    const saveCourtesyPatient = async (_authorization_date, _id_cash) => {


        let _new = moment(now).format("YYYY-MM-DD HH:mm:ss");

        const response = await createCashGlobal(_new, _id_cash);

        if (response.code === 200) {
            showToastAlert("success", "Revisión de corte", "Se a validado correctamente este corte.");
            handleGetGlobalCash()
            toogleAuthorization()
        }
    }

    // ? EXTEMPORANEOUS
    const getFormattedDate = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        const milliseconds = String(now.getMilliseconds()).padStart(3, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
    };


    const [formextemporaneus, setFormExtemporaneous] = useState({
        comment: null,
        amount: 0,
        id_work_order_first: 0,
        id_work_order_last: 0,
        id_user_extemporaneous: 0,
        date_extemporaneous: getFormattedDate(),
        amount_capture: 0,
        id_branch: 0

    });
    const [formNewAmount, setFormNewAmount] = useState({
        observation: null,
        modifiedAmount: 0,
        id_cash_flow: 0,
        amount_cut: 0,
        userCapture: null
    });




    const showSuccess = () => {

        if (toast.current) {
            toast.current.show({
                severity: 'success',
                summary: 'Éxito',
                detail: 'La busqueda del corte se realizo de la manera correcta',
                life: 3000
            });
        }
    };

    const showModalTicket = (_search, _key_detail) => {

        showToastAlert("success", "Información recopilada", "Se obtuvo de manera correcta la información de la caja seleccionada.");


        const cashSelected = _search?.cash?.[_key_detail];

        console.log("Caja seleccionada:", cashSelected);

        const payMethods =
            cashSelected?.status === "Pendiente"
                ? _search?.pay_methods_pending
                : _search?.pay_methods_cut;

        const dataTicket = {
            ..._search,
            cash: cashSelected,
            pay_methods: payMethods ?? []
        };

        setInfoTicket(dataTicket);
        showSuccess();

        setUserCapture(dataTicket.userCapture ?? "----");

        const amountCash = dataTicket.pay_methods
            ?.filter(x => x.id_pay_method === 1)
            .reduce((sum, x) => sum + x.amount, 0) ?? 0;

        setFormExtemporaneous({
            ...formextemporaneus,
            id_work_order_first: dataTicket.first_id_work_order,
            id_work_order_last: dataTicket.end_id_work_order,
            id_user_extemporaneous: dataTicket?.id_user,
            amount_capture: amountCash,
            id_branch: dataTicket?.id_branch
        });
        setVisibleTicket(true);
    };

    const hideModalTicket = () => {
        setVisibleTicket(false);
    };

    const handleComment = (e) => {
        const _comment = e?.target?.value;
        if (e !== null && e?.target?.value !== undefined) {
            setFormExtemporaneous({
                ...formextemporaneus,
                comment: _comment,
            });
        }
        else {
            setFormExtemporaneous({
                ...formextemporaneus,
                comment: null,
            });
        }
    }
    // aca podria ir lo nuevo que va de los datos 
    const handleAmount = (e) => {
        const _amount = e?.target?.value;
        if (e !== null && e?.target?.value !== undefined) {
            setFormExtemporaneous({
                ...formextemporaneus,
                amount: _amount,
            });
        }
        else {
            setFormExtemporaneous({
                ...formextemporaneus,
                amount: null,
            });
        }
    }


    const [idCashFlow, setIdCashFlow] = useState(0);


    useEffect(() => {
        if (idCashFlow > 0) {

        }
    }, [idCashFlow]);




    const createExtemporaneous = async (_fech) => {
        setLoadingExtemporaneous(true)

        if (formextemporaneus.amount === "") {
            setLoadingExtemporaneous(false)
            setShowAlert(true);
            return;
        }

        const create = await createCashExtemporaneous(formextemporaneus.comment, formextemporaneus.amount_capture, formextemporaneus.amount, formextemporaneus.id_branch, formextemporaneus.id_work_order_first, formextemporaneus.id_work_order_last, formextemporaneus.date_extemporaneous, formextemporaneus.id_user_extemporaneous, _fech);

        if (create.code === 200) {

            setIdCashFlow(create.data);

            handleGetGlobalCash(true)
            setFormExtemporaneous({
                ...formextemporaneus,
                id_work_order_first: 0,
                id_work_order_last: 0,
                id_user_extemporaneous: 0,
                amount_capture: 0,
                id_branch: 0,
                amount: 0,
                comment: null,
                date_cash: null
            });
            showToastAlert("success", "Corte extemporaneo", "Se realizo de manera correcta.");

        }
        else {
            setLoadingExtemporaneous(false)
            showToastAlert("warning", "Revisión de corte", "Se genero un problema al crear el corte de caja extemporaneo.");

        }
    }


    const cancelTabChange = () => {

        setShowAlert(false);

    };




    // * FUNCTION FORMAT
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    })

    const [showEvidence, setShowEvidence] = useState(false);
    const [evidenceFile, setEvidenceFile] = useState(null);
    const [listPayMethod, setListPayMethod] = useState([]);


    const handleGetPayMethods = async () => {
        const payMethod = await getAllPayMethod();

        if (payMethod?.length > 0) {
            const list = payMethod?.map(_pay => {
                return {
                    id_pay_method: _pay?.id_pay_method,
                    name: _pay?.name,
                    abbreviation: _pay?.abbreviation,
                    visibility_particular: _pay?.visibility_particular
                }
            });
            setListPayMethod(list);
        }
        else
            setListPayMethod([]);
    }



    // ? NEW PRINT TICKET

    const getPayMethodName = (idPayMethod) => {
        return (
            listPayMethod.find(x => x.id_pay_method === idPayMethod)?.name ??
            "OTRO"
        );
    };

    const buildTicketData = (
        id_cash_flow,
        _valid,
        _is_extemporaneous,
        _search,
        _key_detai
    ) => {

        const cashSelected = _search?.cash?.[_key_detai];

        const payMethods =
            cashSelected?.status === "Pendiente"
                ? _search?.pay_methods_pending
                : _search?.pay_methods_cut;

        const lastPayment =
            payMethods.length > 0
                ? payMethods[payMethods.length - 1]
                : null;

        const total_amount1 = payMethods.reduce(
            (total, payment) => total + Number(payment?.amount ?? 0),
            0
        );

        return {
            id_cash_flow: Number(id_cash_flow),
            total_amountT: total_amount1,
            commercial_line: _commercialLine ?? "",
            branch_name: _branchName ?? "",
            user_name: cashSelected.user_capture ?? "",

            start_date: infoTicket?.start_date ?? _new ?? "",
            end_date:
                infoTicket?.end_date ??
                lastPayment?.created_at ??
                _new ??
                "",

            total_amount: cashSelected.amount,

            registered_cash: cashSelected.captureAmount,

            comment: formextemporaneus?.comment ?? "",

            is_extemporaneous: Boolean(_is_extemporaneous),

            pay_methods: payMethods.map((payment) => ({
                id_pay_method: Number(payment?.id_pay_method ?? 0),

                pay_method: getPayMethodName(
                    Number(payment?.id_pay_method ?? 0)
                ),

                amount: Number(payment?.amount ?? 0),

                created_at: payment?.created_at ?? ""
            }))
        };
    };



    const printTicket2 = async (
        id_cash_flow,
        _valid,
        _is_extemporaneous,
        _search,
        _key_detail,
        rowKey,
        payMethods
    ) => {
        if (!id_cash_flow || id_cash_flow <= 0) {
            return;
        }

        try {
            setLoadingPrintKey(rowKey);

            const token = localStorage.getItem("token");

            const ticketData = buildTicketData(
                id_cash_flow,
                _valid,
                _is_extemporaneous,
                _search,
                _key_detail
            );

            const payMethodNames = {
                1: "EFECTIVO",
                2: "TARJETA DE DÉBITO",
                4: "TARJETA DE CRÉDITO",
                8: "TRANSFERENCIA ELECTRÓNICA DE FONDOS",
                10: "CRÉDITO"
            };

            ticketData.pay_methods = (payMethods ?? []).map((payment) => ({
                ...payment,
                pay_method:
                    payment.pay_method ??
                    payMethodNames[Number(payment.id_pay_method)] ??
                    "MÉTODO DESCONOCIDO"
            }));

            const totalAllMethods = ticketData.pay_methods.reduce((total, payment) => total + Number(payment.amount ?? 0), 0);

            const totalCash = ticketData.pay_methods
                .filter(payment => Number(payment.id_pay_method) === 1)
                .reduce(
                    (total, payment) => total + Number(payment.amount ?? 0),
                    0
                );

            ticketData.total_amount = totalCash;
            ticketData.total_amountT = totalAllMethods;


            console.log("TOTAL EFECTIVO:", ticketData.total_amount);
            console.log("TOTAL TODOS LOS MÉTODOS:", ticketData.total_amountT);
            console.log("TICKET FINAL:", ticketData);


            const response = await fetch(
                `${ConfigServer.serverUrl}/api/CashFlow/PrintTicket2`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`
                    },
                    body: JSON.stringify(ticketData)
                }
            );

            if (!response.ok) {
                const errorText = await response.text();

                throw new Error(
                    errorText || "No fue posible generar el ticket."
                );
            }

            const pdfBlob = await response.blob();
            const pdfUrl = window.URL.createObjectURL(pdfBlob);
            const link = document.createElement("a");

            link.href = pdfUrl;
            link.download = `corte-${id_cash_flow}.pdf`;

            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(pdfUrl);

        } catch (error) {
            console.error("Error al imprimir ticket:", error);
        } finally {
            setLoadingPrintKey(null);
        }
    };


    // ? MODIFIED AMOUNT
    const showModalModifiedAmount = (_search, _key_detail) => {
        console.log("🚀 ~ showModalModifiedAmount ~ _search:", _search)



        const cashSelected = _search?.cash?.[_key_detail];

        console.log("Caja seleccionada:", cashSelected);

        const payMethods =
            cashSelected?.status === "Pendiente"
                ? _search?.pay_methods_pending
                : _search?.pay_methods_cut;

        const dataTicket = {
            ..._search,
            cash: cashSelected,
            pay_methods: payMethods ?? []
        };

        setInfoTicket(dataTicket);

        setFormNewAmount({
            ...formNewAmount,
            id_cash_flow: cashSelected?.id_cash ?? 0,
            amount_cut: dataTicket?.cash?.captureAmount ?? 0,
            userCapture: dataTicket?.userCapture ?? "----"
        });
        setVisibleInfo(true);
    };

    const hideModalAmount = () => {
        setVisibleInfo(false);
    };
    console.log("🚀 ~ showModalModifiedAmount ~ formNewAmount:", formNewAmount)


    const handleCommentModified = (e) => {
        const _comment = e?.target?.value;
        if (e !== null && e?.target?.value !== undefined) {
            setFormNewAmount({
                ...formNewAmount,
                observation: _comment,
            });
        }
        else {
            setFormNewAmount({
                ...formNewAmount,
                observation: null,
            });
        }
    }

    const handleAmountModified = (e) => {
        const _amount = e?.target?.value;
        if (e !== null && e?.target?.value !== undefined) {
            setFormNewAmount({
                ...formNewAmount,
                modifiedAmount: _amount,
            });
        }
        else {
            setFormNewAmount({
                ...formNewAmount,
                modifiedAmount: null,
            });
        }
    }


    const [loadingModified, setLoadingModified] = useState(false)

    const saveModifiedCashFlow = async () => {

        if (formNewAmount.modifiedAmount === null || formNewAmount.modifiedAmount === undefined || formNewAmount.modifiedAmount === "") {
            showToastAlert(
                "warning",
                "Modificación de monto entregado",
                "Debes ingresar la cantidad modificada."
            );

            return;
        }

        if (!formNewAmount.observation || formNewAmount.observation.trim() === "") {
            showToastAlert(
                "warning",
                "Modificación de monto entregado",
                "Debes ingresar la justificación de la modificación."
            );

            return;
        }
        setLoadingModified(true)




        const response = await updateModifiedAmount(formNewAmount.id_cash_flow, formNewAmount.modifiedAmount, formNewAmount.observation);

        if (response.code === 200) {
            setLoadingModified(false)

            showToastAlert("success", "Modificación de monto entregado", "Se a realizado correctamente la modificación.");
            handleGetGlobalCash()
            hideModalAmount()
        }
        else {
            setLoadingModified(false)
            showToastAlert("danger", "Modificación de monto entregado", "No se pudo realizar la modificación.");

        }
    }






    return {
        // ? CONFIGURATION
        _commercialLine, _nameUser, _branchName, _new, _admin_cash,

        // ? FORM 
        date1, date2, handleInputChange,

        // ? TYPE FORMAT
        formatter,

        // ? GLOBAL CASH
        dataAllGlobal, handleGetGlobalCash, amount1, loadingGlobal, amountTotal, amountCancell,

        // ? AUTHORIZATION CASH
        handleSearchAuthorization, selectedKey, toogleAuthorization, modalAuthorization, handleOpenPreview, handleClosedPreview, viewDetail, viewAmount, user, id_cash, saveCourtesyPatient,
        _active_micro, _url_helen,

        // ? EXTEMPORANEOUS
        visibleTicket, showModalTicket, hideModalTicket, infoTicket, toast, userCapture,
        handleComment, handleAmount, formextemporaneus, createExtemporaneous, loadingExtemporaneous,
        showEvidence, setShowEvidence, evidenceFile, setEvidenceFile,

        listPayMethod, showAlert, cancelTabChange,

        printTicket2, loadingPrintKey,

        showToast, toastType, toastTitle, toastMessage, closeToastAlert,

        showModalModifiedAmount, visibleInfo,
        hideModalAmount, formNewAmount,
        handleCommentModified, handleAmountModified,
        saveModifiedCashFlow, loadingModified





    }
}
